<template>
  <div class="machine-container">
    <div>
      <h1 class="">{{ fit20.selectTabId }} Redirect language Urls:</h1>
      <br>
      <div class="search-add-sec">
        <input type="text" placeholder="Search..." @input="filterUrls" ref="searchInput" />
        <img width="50" @click.stop.prevent="showAddUrl('new')"
          src="https://storage.googleapis.com/fit20app-4-acctest.appspot.com/static/icons/%2B.png" />
      </div>
    </div>
    <div class="machines" v-if="filteredUrls && Object.keys(filteredUrls).length > 0">
      <div class="studios-card" v-for="urlKey in Object.keys(filteredUrls)" :key="urlKey">
        <div class="flex url-edit">
          <div>Page key: {{ urlKey }}</div>
          <img data-v-04be2fd4="" width="40" src="https://storage.googleapis.com/fit20app/static/icons/edit.svg"
            @click.stop.prevent="showAddUrl('edit', filteredUrls[urlKey], urlKey)">
        </div>
        <div class="urls-input" :id="urlKey" v-for="lang in Object.keys(filteredUrls[urlKey])">
          <label>{{ lang }}:</label>
          <input type="text" v-model="filteredUrls[urlKey][lang]" disabled placeholder="For example: /home"
            title="The url should be every thing after the country code including the slash" />
        </div>
      </div>
    </div>

    <!-- start add url popup  -->
    <div class="popup-overlay" :class="{ 'remove-center': notCenter }" v-if="newRedirect">

      <div class="edit-member" ref="content">
        <div class='popup-title flex'>
          <span>New URL</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="showAddUrl(false)" />
        </div>
        <div class="flex edit-member-body">
          <form class="session-form-container" id="admin_studio_info">
            <div class="machines" v-if="fit20.urls.routes && Object.keys(fit20.urls.routes).length > 0">
              <div class="new-url-container">

                <div class="urls-input">
                  <label>Page key:(default language url without the first '/') </label>
                  <input type="text" v-model="urlToEdit.pageKey" placeholder="For example: home"
                    title="default language url without the first '/'" :disabled="urlAction == 'edit' ? true : false" />
                </div>
                <div class="urls-input" id="new_URL" v-for="lang in Object.keys(fit20.urls.routes['default'])">
                  <label>{{ lang }}:</label>
                  <input type="text" v-model="urlToEdit[lang]" placeholder="For example: /home"
                    title="The url should be every thing after the country code including the slash" />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="flex btns">
          <div class="btn-container" v-if="urlToEdit.pageKey != 'default' && urlAction != 'new'">
            <span :class="'fit20-btn delete-btn '" @click="saveUrls('delete');">
              Delete
            </span>
          </div>
          <div class="btn-container">
            <span :class="'fit20-btn ' + (isChanged ? 'save-btn-active' : 'save-btn-disable')"
              @click="saveUrls(urlAction);">
              Save
            </span>
          </div>

        </div>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';
export default {
  name: 'Urls',
  components: {},
  props: ["fit20"],
  data() {
    return {
      notCenter: false,
      newRedirect: false,
      urls: [],
      filteredUrls: [],
      inputValue: '',
      urlToEdit: null,
      isChanged: false,
      originalUrls: false,
      urlAction: false,
      originalUrlToEdit: null,
    };
  },
  methods: {
    async getURLS(countryName) {
      console.log("start getting urls");
      console.log(countryName);
      //console.log(code);
      this.fit20.isLoaded = false;
      try {
        const getAllUrls = await fetch(this.fit20.baseUrl + "/api/block/Routes?code=" + countryName);
        let data = await getAllUrls.json();
        console.log(data);
        if (data && data.msg) {
          //this.fit20.studios = [];
        } else {
          this.urls = data;
          this.urls.routes = JSON.parse(this.urls.routes);
        }

        console.log(this.urls.routes.default);
        this.fit20.isLoaded = true;
      } catch (err) {
        console.log(err);
        this.fit20.isLoaded = true;
        alert(err);
      }
      //this.selectTab(name, code);
    },
    cancelEditing() {
      // console.log(this.originalUrls);
      this.fit20.urls.routes = JSON.parse(JSON.stringify(this.originalUrls.routes));
    },
    showAddUrl(action, url, key) {
      this.urlAction = action;
      if (action == "new") {
        this.newRedirect = true;
        this.urlToEdit = {
          pageKey: ''
        };
      } else if (action == "edit") {
        this.newRedirect = true;
        // console.log(key);
        // console.log(url);
        this.originalUrlToEdit = JSON.parse(JSON.stringify(url));
        this.originalUrlToEdit.pageKey = key;
        this.urlToEdit = JSON.parse(JSON.stringify(url));
        this.urlToEdit.pageKey = key;
        console.log(this.urlToEdit);
      } else {
        this.newRedirect = false;
        this.urlToEdit = null;
        this.urlAction = false;
        this.originalUrlToEdit = null;
      }

    },
    getStudio(name) {
      this.checkAlign();

    },
    async saveUrls(action) {
      this.checkAlign();
      // to do >>>>>>> correct the checking before save and all save possess >>>>>>>>>>>
      if (action == 'edit' && isEqual(this.urlToEdit, this.originalUrlToEdit)) {
        this.showAddUrl(false);
        alert('No changes to save');
        // this.urlToEdit = null;
      } else if (Object.values(this.urlToEdit).length != 3 || Object.values(this.urlToEdit).some(value => value == "")) {
        alert("all fields are required");
      }
      else if (action == 'new' && this.fit20.urls.routes[this.urlToEdit.pageKey]) {
        alert('This page key: ' + this.urlToEdit.pageKey + ' is already exist');
      }
      else {

        const { pageKey, ...rest } = this.urlToEdit;
        //this.fit20.urls.routes[this.urlToEdit.pageKey] = rest;
        let newRouts = JSON.parse(JSON.stringify(this.fit20.urls));
        newRouts.routes[this.urlToEdit.pageKey] = rest;
        console.log(newRouts);
        if (action == 'delete') {
          if (pageKey == 'default') {
            alert("Sorry , you can't delete the default redirect!");
            this.showAddUrl(false);
            return
          } else if (confirm("Are you sure you want to delete this URL redirect?")) {
            const { pageKey, ...rest } = newRouts.routes;
            newRouts.routes = JSON.parse(JSON.stringify(rest));
            console.log(newRouts);
          }
        }
        // }

        // let updateBlock = await fetch(this.fit20.baseUrl + "/api/block/Routes/" + this.fit20.user.email + "?code=" + this.fit20.urls.id + "&accessToken=" + localStorage.getItem('access_token'), {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json'
        //   },
        //   body: JSON.stringify(newRouts),
        // });
        // let updatedURLs = await updateBlock.json();
        // if (updatedURLs && !updatedURLs.msg) {
        //   this.originalUrls = JSON.parse(JSON.stringify(newRouts));
        //   this.fit20.urls.routes = JSON.parse(JSON.stringify(newRouts.routes));
        // }
        // else {
        //   alert('Something went wrong...!');
        // }
        this.showAddUrl(false);
      }

    },
    checkAlign() {
      const content = this.$refs.content;
      if (!content) return;
      console.log('check align');
      this.notCenter = content.offsetHeight > window.innerHeight;
    },
    filterUrls(event) {
      this.inputValue = event;
      let searchWord = event.target.value.toLowerCase().trim()
      if (searchWord.length > 0) {
        this.filteredUrls =
          Object.fromEntries(
            Object.entries(this.fit20.urls.routes).filter(([key, valueObj]) => {
              const keyMatch = key.toLowerCase().includes(searchWord)

              const valueMatch = Object.values(valueObj).some(v =>
                v.toLowerCase().includes(searchWord)
              )

              return keyMatch || valueMatch
            })
          );
      } else {
        this.filteredUrls = JSON.parse(JSON.stringify(this.fit20.urls.routes));
      }
    },
  },
  mounted: async function () {
    this.$nextTick(() => {
      this.checkAlign();
      window.addEventListener("resize", this.checkAlign);
    });
  },
  created: async function () {
    // await getURLS();
    console.log('CREATE');
    // console.log(this.originalUrls);

    //this.originalUrls = JSON.parse(JSON.stringify(this.fit20.urls));
    //console.log(this.originalUrls);

  },
  watch: {
    'fit20.urls': {
      immediate: false, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        console.log(newVal);
        this.inputValue = "";
        if (this.$refs.searchInput && this.$refs.searchInput.value) {
          this.$refs.searchInput.value = '';
        }

        if (!this.inputValue) {
          this.filteredUrls = JSON.parse(JSON.stringify(newVal.routes));
          console.log("watcher 1");
        }
        console.log(newVal);
        if (!this.originalUrls) {
          this.originalUrls = JSON.parse(JSON.stringify(newVal));
          console.log("watcher2 2");
        }
      }
    },
    // filteredUrls: {
    //   immediate: false, // This runs the watcher immediately on mount
    //   deep: true, // Watch for changes in nested properties
    //   handler(newVal) {
    //     console.log(newVal);

    //     if (!isEqual(this.fit20.urls, this.originalUrls)) {
    //       this.isChanged = true;
    //     } else {
    //       this.isChanged = false;
    //     }
    //     console.log(this.isChanged);
    //   }
    // }
  }
};
</script>

<style scoped>
.url-edit {
  justify-content: space-between;
}

h1 {
  color: var(--fit20-blue);
}

.inactive {
  background-color: rgb(216, 216, 216);
}

.machine-container {
  /* position: absolute;
  top: 0;
  left: 0; */
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
}

.search-add-sec {
  display: flex;
  justify-content: space-between;
  padding-right: 15px;
}

.search-add-sec img {
  width: 50px;
}

.machine-container input {
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  padding: 7px 5px;
  width: 90%;
}

.machines {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-height: calc(100% - 100px);
  /* Adjust as needed */
  /* overflow: auto;*/
  margin-top: 10px;
}

.studios-card {
  display: flex;
  flex-direction: column;
  margin: 5px;
  border: solid 1px var(--fit20-lighter-gray);
  width: calc(100% / 3 - 20px);
  /* min-height: 40px; */
  border-radius: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
}

.new-url-container {
  display: flex;
  flex-direction: column;
  margin: 5px;
  border: solid 1px var(--fit20-lighter-gray);
  width: 100%;
  /* min-height: 40px; */
  border-radius: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  align-items: center;
}

.new-url-container div label {
  display: block;
}

.new-url-container div,
.new-url-container div label {
  width: 70%;
}

.studios-card-inactive {
  background-color: var(--fit20-lighter-gray);
}

.selected {
  background-color: var(--fit20-blue);
  color: white !important;
  text-align: center;
  transition: all .8s;
}

.selected a {
  color: white !important;
}

.machine-card a {
  display: inline-block;
  width: 100%;
  height: 100%;
  /* margin-left: 10px; */
}

/* img {
  width: 35%;
  max-width: 110px;
  min-width: 70px;
  min-height: 70px;
} */
.edit-member {
  background-color: white;
  border-radius: 10px;
  width: 90%;
  /* max-height: 100%; */
  height: fit-content;
}

.edit-member-body {
  margin-top: 5px;
  padding-bottom: 10px;
  overflow: scroll;
  /* max-height: 600px; */
}

.edit-member-body>form {
  width: 100%;
  padding-left: 10px;
}

.edit-member-1sec>.field-sec {
  width: 33%;
}

.field-sec {
  margin-top: 15px;
}

.field-sec.flex>label {
  padding: 0px 0px 0px 10px;
  /* margin-left: 10px; */
}

.member-info.flex {
  flex-wrap: nowrap;
}

.session-form-container input,
.session-form-container select,
.session-form-container textarea {
  width: 95%;
  background-color: white;
  padding-left: 5px;
  border-radius: 5px;
  color: black;
  border: solid 1px var(--fit20-lighter-gray);
}

.session-form-container input,
.session-form-container select {
  height: 30px;
  background-color: white;
  padding-left: 5px;
  border-radius: 5px;
  color: black;
  border: solid 1px var(--fit20-lighter-gray);
}

.field-sec.flex>label {
  width: 48%;
}

.field-sec.flex>input {
  width: fit-content;
}

.session-studio-container input.height {
  width: 60px !important;
  text-align: center;
}

.session-studio-container .fake-div {
  height: 88%;
}

.session-studio-container .close-popup {
  width: 30px;
  padding: 5px;
}

.remove-center {
  align-items: start;
}

.urls-input {
  margin: 5px 0;
}

.delete-btn {
  color: white !important;
  background-color: var(--fit20-pink) !important;
  transition: all 1s;

}

.btns {
  justify-content: end;
}
</style>
